import Vue from 'vue'
import Router from 'vue-router'
import Home from './components/home/Home'
import Login from './components/common/Login'
import SignUp from './components/signup/SignUp'
import Registration from './components/signup/Registration'
import Billing from './components/signup/Billing'
import ForgottenPassword from './components/common/ForgottenPassword'
import RestoreAccount from './components/common/RestoreAccount'
import Dashboard from './components/dashboard/Dashboard'
import BrandReports from './components/dashboard/BrandReports'
import OppositionReports from './components/dashboard/OppositionReports'
import AddEditBrand from './components/dashboard/AddEditBrand'
import BrandDetails from './components/dashboard/BrandDetails'
import AddEditOpposition from './components/dashboard/AddEditOpposition'
import OppositionDetails from './components/dashboard/OppositionDetails'
import Reports from './components/dashboard/reports/Reports'
import ReportDetails from './components/dashboard/reports/ReportDetails'
import SearchInDatabase from './components/dashboard/search/SearchInDatabase'
import UploadTrademark from './components/dashboard/upload/UploadTrademark'
import UserList from './components/dashboard/user/UserList'
import OwnersList from './components/dashboard/owners/OwnersList'
import User from './components/dashboard/user/User'
import ActivateAccount from './components/common/ActivateAccount'
import Success from './components/signup/Success'
import InfoPage from './components/common/InfoPage'
import EditLoggedUser from './components/dashboard/loggedUser/EditLoggedUser'
import SingleReport from "./components/dashboard/reports/SingleReport"
import SingleSearchResult from './components/dashboard/search/SingleSearchResult'
import UpgradePlan from './components/dashboard/loggedUser/UpgradePlan'

import store from './store'
Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
    if (!store.getters.isAuthenticated) {
        next('/login')
        return;
    }
    next();
};

const ifAuthenticated = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        next('/dashboard');
        return;
    }
    next();
};

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            beforeEnter: ifAuthenticated,
            component: Home
        },
        {
            path: '/info',
            name: 'info',
            component: InfoPage
        },
        {
            path: '/activate',
            name: 'activateAccount',
            beforeEnter: ifAuthenticated,
            component: ActivateAccount
        },
        {
            path: '/login',
            name: 'login',
            beforeEnter: ifAuthenticated,
            component: Login
        },
        {
            path: '/forgotten-password',
            name: 'forgottenPassword',
            beforeEnter: ifAuthenticated,
            component: ForgottenPassword
        },
        {
            path: '/restore-account',
            name: 'restoreAccount',
            beforeEnter: ifAuthenticated,
            component: RestoreAccount
        },
        {
            path: '/signup',
            component: SignUp,
            beforeEnter: ifAuthenticated,
            children: [
                {
                    path: '',
                    name: 'Registration',
                    component: Registration
                },
                {
                    path: 'billing',
                    name: 'Billing',
                    component: Billing
                },
                {
                    path: 'success',
                    name: 'Success',
                    component: Success
                },
            ]
        },
        {
            path: '/dashboard',
            component: Dashboard,
            children: [
                {
                    path: '',
                    name: 'BrandReports',
                    beforeEnter: ifNotAuthenticated,
                    component: BrandReports
                },
                {
                    path: 'oppositions',
                    name: 'OppositionReports',
                    beforeEnter: ifNotAuthenticated,
                    component: OppositionReports
                },
                {
                    path: 'add-brand',
                    name: 'AddBrand',
                    beforeEnter: ifNotAuthenticated,
                    component: AddEditBrand
                },
                {
                    path: 'edit-brand/:id',
                    name: 'EditBrand',
                    beforeEnter: ifNotAuthenticated,
                    component: AddEditBrand,
                    props: true
                },
                {
                    path: 'brand/:id',
                    name: 'BrandDetails',
                    props: true,
                    beforeEnter: ifNotAuthenticated,
                    component: BrandDetails
                },
                {
                    path: 'add-opposition',
                    name: 'AddOpposition',
                    beforeEnter: ifNotAuthenticated,
                    component: AddEditOpposition
                },
                {
                    path: 'edit-opposition/:id',
                    name: 'EditOpposition',
                    beforeEnter: ifNotAuthenticated,
                    component: AddEditOpposition,
                    props: true
                },
                {
                    path: 'opposition/:id',
                    name: 'OppositionDetails',
                    props: true,
                    beforeEnter: ifNotAuthenticated,
                    component: OppositionDetails
                },
                {
                    path: 'reports/:owner?/:brand?',
                    name: 'Reports',
                    props: true,
                    beforeEnter: ifNotAuthenticated,
                    component: Reports
                },
                {
                    path: 'reports-details/:id',
                    name: 'ReportDetails',
                    props: true,
                    beforeEnter: ifNotAuthenticated,
                    component: ReportDetails,
                },
                {
                    path: 'report/:id',
                    name: 'SingleReport',
                    props: true,
                    beforeEnter: ifNotAuthenticated,
                    component: SingleReport,
                },
                {
                    path: 'search',
                    name: 'SearchInDatabase',
                    beforeEnter: ifNotAuthenticated,
                    component: SearchInDatabase
                },
                {
                    path: 'search/:id',
                    name: 'SingleSearchResult',
                    props: true,
                    beforeEnter: ifNotAuthenticated,
                    component: SingleSearchResult
                },
                {
                    path: 'upload',
                    name: 'UploadTrademark',
                    beforeEnter: ifNotAuthenticated,
                    component: UploadTrademark
                },
                {
                    path: 'owners',
                    name: 'OwnersList',
                    beforeEnter: ifNotAuthenticated,
                    component: OwnersList
                },
                {
                    path: 'users',
                    name: 'UserList',
                    beforeEnter: ifNotAuthenticated,
                    component: UserList
                },
                {
                    path: 'users/add',
                    name: 'AddUser',
                    beforeEnter: ifNotAuthenticated,
                    component: User
                },
                {
                    path: 'users/edit/:id',
                    name: 'EditUser',
                    beforeEnter: ifNotAuthenticated,
                    component: User
                },
                {
                    path: 'profile',
                    name: 'EditLoggedUser',
                    beforeEnter: ifNotAuthenticated,
                    component: EditLoggedUser
                },
                {
                    path: 'upgrade-plan',
                    name: 'UpgradePlan',
                    beforeEnter: ifNotAuthenticated,
                    component: UpgradePlan
                }
            ]
        },
    ],
    scrollBehavior: () => {
        document.getElementById('app').scrollIntoView();
        return null;
    }
})
